"use client";

import React from "react";
import { useTranslation } from "react-i18next";

const CopyrightPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="p-8 font-sans leading-relaxed max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-center mb-8">
        {t("copyright_page.title")}
      </h1>
      <p>
        <strong className="font-semibold">
          {t("copyright_page.last_updated")}:
        </strong>{" "}
        {t("copyright_page.date_placeholder")}
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("copyright_page.notice_title")}
      </h2>
      <p className="mb-4">{t("copyright_page.notice_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("copyright_page.ownership_title")}
      </h2>
      <p className="mb-4">{t("copyright_page.ownership_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("copyright_page.permissions_title")}
      </h2>
      <p className="mb-4">{t("copyright_page.permissions_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("copyright_page.reporting_title")}
      </h2>
      <p className="mb-4">{t("copyright_page.reporting_content")}</p>

      <p className="mb-4">
        {t("copyright_page.contact_email_label")}{" "}
        <a
          href={`mailto:${t("copyright_page.contact_email")}`}
          className="text-blue-600 hover:underline"
        >
          {t("copyright_page.contact_email")}
        </a>
      </p>
    </div>
  );
};

export default CopyrightPage;
